<script setup>

</script>

<template>
	<section class="search-container"> 
		<div class="search-control" >
			<img src="@/assets/images/search.png" class="search-img" height="16" width="16">
			<input id="search-text" type="text" class="search-input" />
		</div>
	</section>
</template>

<style scoped>
.search-container {
	
}

.search-img {
	padding: .75rem;
	box-sizing: content-box;
}
.search-control {
	margin-top: 0;
	height: 2.5rem;
	width: 100%;
	background: var(--surface-Default, #FFF);	
    display: flex;
    justify-content: flex-start;
    align-items: center;

	border-radius: 0.25rem;
	border: 1px solid var(--border-color-input-Border, #A9B7C7);
}

.search-input {
	height: 100%;
    border: 0;
	width: 20rem;
}

</style>